import PremiumOverlayCard from '@hellodarwin/app-core/lib/layouts/premium-access/components/premium-paywall-overlay/premium-overlay-card';
import { usePremiumAccess } from '@hellodarwin/app-core/lib/providers/premium-access-provider';
import Loading from '@hellodarwin/core/lib/components/loading';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch } from '../../../app/app-hooks';
import { fetchIsClientFacing } from '../../../features/api/slices/gin-steps-slice';
import { useNewClientApi } from '../../../features/api/use-client-api';
import ClientSingleApplication from './v2';
import { ClientSingleApplicationPageContainer } from './styles';

const ClientSingleApplicationPage = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const api = useNewClientApi();
  const { programId } = useParams();
  const [viewMode, setViewMode] = useState<'v2' | undefined>(undefined);
  const { isSectionAccessible } = usePremiumAccess();
  const isAccessible = isSectionAccessible('premium');

  useEffect(() => {
    setViewMode(undefined);
    if (!programId) return;
    dispatch(fetchIsClientFacing({ api, programId }))
      .unwrap()
      .then(() => {
        setViewMode(getViewMode());
      });
  }, [dispatch, api, programId]);

  const getViewMode = (): 'v2' | undefined => {
    return 'v2';
  };

  const handlePremiumOverlayClose = () => {
    if (window.history.length > 2 && window.location.hash) {
      navigate(-2);
    } else {
      navigate('/dashboard');
    }
  };

  if (viewMode == null) return <Loading />;

  return (
    <>
      <div style={{ filter: !isAccessible ? 'blur(5px)' : undefined }}>
        <ClientSingleApplication />
      </div>

      {!isAccessible && (
        <ClientSingleApplicationPageContainer>
          <PremiumOverlayCard onClose={handlePremiumOverlayClose} />
        </ClientSingleApplicationPageContainer>
      )}
    </>
  );
};

export default ClientSingleApplicationPage;
